export default class Testimonial {
  constructor(image, clientName, clientBusiness, testimonial) {
    this.image = image;
    this.client_name = clientName;
    this.client_business = clientBusiness;
    this.testimonial = testimonial;
  }
}
